import { Reducer } from 'redux';

import {
  TypeaheadEnterAction,
  TypeaheadLeaveAction,
  TypeaheadPendingAction,
  TypeaheadSelectPickerItemAction,
} from '../../domains/typeahead/actions.types';

import { SearchSession } from './types';

export type SearchSessionIdAction =
  | TypeaheadEnterAction
  | TypeaheadLeaveAction
  | TypeaheadSelectPickerItemAction
  | TypeaheadPendingAction;

const initialState: SearchSession = {
  conversationId: undefined,
  logicalId: undefined,
};

const startSearchSession = (state: SearchSession, { payload }: TypeaheadEnterAction) => ({
  ...state,
  conversationId: payload.conversationId,
  conversationStart: payload.conversationStart,
  logicalId: payload.logicalId,
});

const endSearchSession = (state: SearchSession) => ({
  ...state,
  conversationId: undefined,
  conversationStart: undefined,
  logicalId: undefined,
});

const updateSearchSessionLogicalId = (state: SearchSession, { payload }: TypeaheadPendingAction) => ({
  ...state,
  logicalId: payload.logicalId,
});

const reducer: Reducer<SearchSession, SearchSessionIdAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TYPEAHEAD.ENTER':
      return startSearchSession(state, action);
    case 'TYPEAHEAD.SELECT_PICKER_ITEM':
      return endSearchSession(state);
    case 'TYPEAHEAD.LEAVE':
      return endSearchSession(state);
    case 'TYPEAHEAD.LOAD_PENDING':
      return updateSearchSessionLogicalId(state, action);
    default:
      return state;
  }
};

export default reducer;
